//  filepath: src/utils/storage.js
export const readLocal = (key, fallback) => {
  try {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(v) : fallback;
  } catch {
    return fallback;
  }
};
export const getAny = (key) =>
  localStorage.getItem(key) ?? sessionStorage.getItem(key) ?? null;
